import { render } from "./callToActionOfferBlock.vue?vue&type=template&id=581aff5c&scoped=true&ts=true"
import script from "./callToActionOfferBlock.vue?vue&type=script&lang=ts"
export * from "./callToActionOfferBlock.vue?vue&type=script&lang=ts"

import "./callToActionOfferBlock.vue?vue&type=style&index=0&id=581aff5c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581aff5c"]])

export default __exports__